define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/action/_ImageBrowseMixin",
	"csi/state/rootStore",
	"csi/gallery/AggregateFrom"
], function(declare, _, _ImageBrowseMixin, { routerStore }, AggregateFrom) {

	return declare([AggregateFrom, _ImageBrowseMixin], {
		process: function() {
			// summary: add selected images to FormData and continue as normal
			var fd = this.getFormData();

			_.each(this._imageUrls, function(url) {
				fd.changeSelection(this.getContext(url), true);
			}, this.widget);

			this.inherited(arguments);
		},

		_getImageContext: function() {
			// summary: return Style as image context
			return routerStore.getBreadcrumbNode("Style");
		}
	});
});